import { Flex, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import { alertsColumnIconMap } from "../../../../Utils/utils"

const { Text, Link } = Typography

dayjs.extend(utc)

const renderPriceOrLevels = (_, levels) => {
  if (_) {
    return (
      <Text>
        <Private>{`$ ${_}`}</Private>
      </Text>
    )
  } else if (levels) {
    return (
      <Flex align="center" gap={4}>
        <Text>
          {levels?.length} level{levels?.length ? "s" : ""}
        </Text>
        <Tooltip
          title={
            <Flex vertical>
              {levels?.map((level, index) => {
                let from = index ? levels[index - 1]?.["range_to"] + 1 : 1
                let to = level?.["range_to"]
                return (
                  <span key={level.id}>
                    {`${from}${to ? `-${to}` : "+"} alerts — `}
                    <Private>{`$${level.price}`}</Private>
                  </span>
                )
              })}
            </Flex>
          }
        >
          <div className="text-with-icon">
            <Icon type="circle_info" style={{ fontSize: 20 }} />
          </div>
        </Tooltip>
      </Flex>
    )
  } else {
    return "-"
  }
}

export const getColumns = () => ({
  id: {
    key: "sequence_number",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: null,
        sorter: true,
        icon: alertsColumnIconMap["sequence_number"],
        stateData: state,
        key: "sequence_number"
      }),
    dataIndex: "sequence_number",
    width: 80,
    fixed: "left"
  },

  ethoca_price: {
    key: "ethoca_price",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Ethoca",
        sorter: true,
        icon: alertsColumnIconMap["ethoca_price"],
        stateData: state,
        key: "ethoca_price"
      }),
    dataIndex: "ethoca_price",
    width: 130,
    render: (_, record) => renderPriceOrLevels(_, record?.["ethoca_price_levels"])
  },

  rdr_1_price: {
    key: "rdr_1_price",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "RDR",
        sorter: true,
        icon: alertsColumnIconMap["rdr_1_price"],
        stateData: state,
        key: "rdr_1_price"
      }),
    dataIndex: "rdr_1_price",
    width: 130,
    render: (_, record) => renderPriceOrLevels(_, record?.["rdr_1_price_levels"])
  },

  cdrn_price: {
    key: "cdrn_price",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "CDRN",
        sorter: true,
        icon: alertsColumnIconMap["cdrn_price"],
        stateData: state,
        key: "cdrn_price"
      }),
    dataIndex: "cdrn_price",
    width: 130,
    render: (_, record) => renderPriceOrLevels(_, record?.["cdrn_price_levels"])
  },
  count_of_free_alerts: {
    key: "count_of_free_alerts",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Free alerts",
        sorter: true,
        icon: alertsColumnIconMap["count_of_free_alerts"],
        stateData: state,
        key: "count_of_free_alerts"
      }),
    dataIndex: "count_of_free_alerts",
    width: 290
    //render: (_) => _ ? 'Yes' : 'No'
  },
  applied: {
    key: "applied",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Applied",
        sorter: true,
        icon: alertsColumnIconMap["applied"],
        stateData: state,
        key: "applied"
      }),
    dataIndex: "applied",
    width: 130,
    render: (_) => (_ ? "Yes" : "No")
  }
})

export const getDefaultColumn = ({ field_id, label, t }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      //icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  width: 185,
  ellipsis: true
})

export const getActionColumn = ({ onSelectRow }) => {
  const handleAction = (e, data, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow(data, type)
  }
  return {
    key: "action",
    title: "Actions",
    width: 118,
    render: (_, record) => (
      <Flex gap={4}>
        <Tooltip title="Settings">
          <ButtonComponent
            type="link"
            shape="circle"
            icon={<Icon type={"settings"} />}
            onClick={(e) => handleAction(e, record, "settings")}
            className="flex center"
          />
        </Tooltip>

        <Tooltip title="Delete">
          <ButtonComponent
            danger
            type="link"
            shape="circle"
            icon={<Icon type="delete" />}
            onClick={(e) => handleAction(e, record, "delete")}
            disabled={record?.["pricing_schema"]?.toLowerCase() === "default"}
            className="flex center table-action-btn"
          />
        </Tooltip>
      </Flex>
    )
  }
}
